export default class LoyaltyReporting {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-reporting");

    if (!this.$el) {
      return;
    }

    this.$tabButtons = this.$el.querySelectorAll(
      ".js-loyalty-reporting-tab-button"
    );
    this.$galleryImages = this.$el.querySelectorAll(
      ".js-loyalty-reporting-gallery img"
    );

    this.timer = null;
    this.selectedIndex = 0;
    this.duration = 2000;

    this.$tabButtons.forEach(($tab, index) => {
      const $progress = $tab.querySelector(
        ".js-loyalty-reporting-tab-button-progress"
      );

      $progress.addEventListener("animationend", () => {
        const $nextTab = this.$tabButtons[index + 1];

        if (!$nextTab) {
          this.$tabButtons[0].click();
        } else {
          $nextTab.click();
        }
      });

      $tab.addEventListener("click", () => {
        this.hideAllImages();
        this.hideAllTabs();

        $tab.classList.add("is-active");
        this.$galleryImages[index].classList.add("is-active");
      });
    });
  }

  hideAllTabs() {
    this.$tabButtons.forEach((tab) => {
      tab.classList.remove("is-active");
    });
  }

  hideAllImages() {
    this.$galleryImages.forEach((image) => {
      image.classList.remove("is-active");
    });
  }
}
